import { useEffect, useState, useContext } from "react"
import { Link, useNavigate } from "react-router-dom"
import cardicon01 from "../../assets/images/card-icon-01.svg"
import cardicon02 from "../../assets/images/card-icon-02.svg"
import cardicon03 from "../../assets/images/card-icon-03.svg"
import cardicon04 from "../../assets/images/card-icon-04.svg"
import { baseUrl } from "../../config/baseUrl"
import axios from "axios"
import loaderContext from "../../context/LoaderContext"
// import DashboardChartAndTable from "./DashboardChartAndTable"
import { Users, Heart, DollarSign, Shield } from "lucide-react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faBookOpen, faDollar, faUser, faUsers } from "@fortawesome/free-solid-svg-icons"


export default function Dashboard() {
  const navigate = useNavigate()
  const { setLoader } = useContext(loaderContext)
  const [allCount, setAllCount] = useState({})
  // const loginUser = JSON.parse(localStorage.getItem("user"))

  useEffect(() => {
    apiCall()
  }, [])
  // console.log("allCount", allCount)

  const apiCall = async () => {
    try {
      setLoader(true)
      // const response = await axios(`http://localhost:3000/admin/dashboard/stats`, {
      const response = await axios(`${baseUrl}/admin/dashboard/stats`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      // console.log("response", response)
      setAllCount(response?.data.data)
    } catch (error) {
      console.error("Error fetching dashboard data:", error)
    } finally {
      setLoader(false)
    }
  }

  return (
    <>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-home me-2" />
                Dashboard
              </h4>
            </div>
          </div>
          <div className="col-lg-12 col-md-8">
            <div className="row mb-3">
              {/* Your existing cards */}
              <div className="col-lg-3 col-md-6">
                <Link to="/users">
                  <div className="dash-card prple-clr">
                    <p>Total Users
                      <span className="ms-2"><Users size={26} /></span>
                      {/* <FontAwesomeIcon icon={faUsers} className="ms-2" /> */}
                    </p>
                    <h5>
                      <span className="counter">{allCount?.userCount - 1 || "0"}</span>
                    </h5>
                    <img src={cardicon01 || "/placeholder.svg"} className="card-icon" alt="cardicon01" />
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-6">
                <Link to="/animals-list">
                  <div className="dash-card sky-clr">
                    <p>
                      Total Matrimonial
                      <span className="ms-2"><Heart size={26} /></span>
                      {/* <FontAwesomeIcon icon={faBookOpen} className="ms-2" /> */}
                    </p>

                    <h5>
                      <span className="counter">{allCount?.animalCount || "0"}</span>
                    </h5>
                    <img src={cardicon02 || "/placeholder.svg"} className="card-icon" alt="cardicon02" />
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-6">
                <Link to="/loans">
                  <div className="dash-card org-clr">
                    <p>
                      Reports
                      <span className="ms-2"><DollarSign size={26} /></span>
                      {/* <FontAwesomeIcon icon={faDollar} className="ms-2" /> */}
                    </p>
                    <h5>
                      <span className="counter">{allCount?.loanCount || "0"}</span>
                    </h5>
                    <img src={cardicon03 || "/placeholder.svg"} className="card-icon" alt="cardicon03" />
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-6">
                <Link to="/insurance-history">
                  <div className="dash-card pnk-clr">
                    <p>
                      Total News
                      <span className="ms-2"><Shield size={26} /></span>
                      {/* <FontAwesomeIcon icon={faBookOpen} className="ms-2" /> */}
                    </p>
                    <h5>
                      <span className="counter">{allCount?.insuranceCount || "0"}</span>
                    </h5>
                    <img src={cardicon04 || "/placeholder.svg"} className="card-icon" alt="cardicon04" />
                  </div>
                </Link>
              </div>

              {/* Add the chart and tables component here */}
              {/* {!allCount && <DashboardChartAndTable dashboardData={allCount} />} */}
            </div>
          </div>
        </div>
      </section>

      {/* video model */}
      <div
        className="modal fade video"
        id="video-popup"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <iframe
                width="100%"
                height={500}
                src="https://www.youtube.com/embed/yAoLSRbwxL8?si=jQNYMNhkHAWel9v2"
                title="YouTube video player"
                frameBorder={0}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen=""
              />
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
